import React from 'react';
import { Phone, Wrench, MapPin } from 'lucide-react';
import { ADRESSE, MAPS_URL } from '../../data/avis';
import { HORAIRES, RDV_MENTION, ENTREPRISE } from '../../data/entreprise';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact</h3>
            <div className="space-y-3">
              <a href="tel:0773601521" className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors">
                <Phone className="w-5 h-5" />
                <span>07.73.60.15.21</span>
              </a>
              <a href={`https://wa.me/33773601521`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
                <span>WhatsApp</span>
              </a>
              <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-address-link" className="flex items-start gap-3 text-gray-300 hover:text-white transition-colors">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span>{ADRESSE}</span>
              </a>
            </div>
          </div>

          {/* Horaires */}
          <div>
            <h3 className="text-xl font-bold mb-4">Horaires d'ouverture</h3>
            <div className="space-y-2 text-gray-300">
              {HORAIRES.map((h) => (
                <div key={h.jours} className="flex justify-between" data-testid="footer-horaire">
                  <span>{h.jours}</span>
                  <span className={h.heures === 'Fermé' ? 'text-gray-500' : 'font-semibold text-white'}>{h.heures}</span>
                </div>
              ))}
              <div className="mt-4 pt-4 border-t border-gray-700">
                <p className="text-sm text-blue-400 font-semibold">✓ {RDV_MENTION}</p>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-xl font-bold mb-4">Navigation</h3>
            <div className="space-y-2">
              <Link to="/" className="block text-gray-300 hover:text-white transition-colors">Accueil</Link>
              <Link to="/rendez-vous" className="block text-gray-300 hover:text-white transition-colors">Prendre RDV – Devis gratuit</Link>
              <Link to="/zones-intervention" data-testid="footer-zones-link" className="block text-gray-300 hover:text-white transition-colors">Zones d'intervention (Loire 42)</Link>
              <Link to="/reparation-iphone-saint-chamond" className="block text-gray-300 hover:text-white transition-colors">Réparation iPhone Saint-Chamond</Link>
              <Link to="/reparation-samsung-saint-chamond" className="block text-gray-300 hover:text-white transition-colors">Réparation Samsung Saint-Chamond</Link>
              <Link to="/reparation-telephone-saint-etienne" className="block text-gray-300 hover:text-white transition-colors">Réparation téléphone Saint-Étienne</Link>
              <Link to="/blog" className="block text-gray-300 hover:text-white transition-colors">Blog</Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 text-center">
          <p className="text-gray-400 mb-2">© 2026 Suro Phone - Réparation iPhone & Samsung à Saint-Chamond et dans toute la Loire (42)</p>
          <p className="text-gray-500 text-sm mb-3">{ENTREPRISE.formeJuridique} · SIRET {ENTREPRISE.siret}</p>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-sm">
            <Link to="/mentions-legales" data-testid="footer-mentions-link" className="text-gray-400 hover:text-white transition-colors">Mentions légales</Link>
            <Link to="/cgv" data-testid="footer-cgv-link" className="text-gray-400 hover:text-white transition-colors">CGV</Link>
            <Link to="/politique-de-confidentialite" data-testid="footer-confidentialite-link" className="text-gray-400 hover:text-white transition-colors">Politique de confidentialité</Link>
          </div>
          <a 
            href="https://app.emergent.sh/?utm_source=emergent-badge" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-gray-500 hover:text-white transition-colors text-sm"
          >
            <Wrench className="w-4 h-4" />
            <span>Made with Emergent</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;